import { render, staticRenderFns } from "./role-add-or-update.vue?vue&type=template&id=514750f2"
import script from "./role-add-or-update.vue?vue&type=script&lang=js"
export * from "./role-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./role-add-or-update.vue?vue&type=style&index=0&id=514750f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports